window.addEventListener('load', function () {
    setTimeout(function() {
        var el = document.querySelector('.product-info__block-item .meety-block-buttons');
        if (el) {
            el.classList.add('mainova-meety-visible');
        }
    }, 0);
});